import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import linkTransformer from "../utils/linkTransformer"
import Button from "./Button"
import Picture from "./Picture"
import Link from "./Link"

const StyledIconGrid = styled.div`
  ${tw`flex flex-wrap -ml-2 -mt-2`}
`
const IconGridColumn = styled.div`
  ${tw`w-full pl-2 mt-2`}
  ${(props) => props.columns === "n2" && tw`lg:w-1/2`}
`

const StyledIconGridItem = styled.div`
  ${tw`flex bg-gray-light min-h-full p-4`}
`
const IconCol = styled.div`
  ${tw`w-32`}
  flex-shrink: 0;
`
const TextCol = styled.div`
  ${tw``}
`

const Text = styled.div`
  ${tw`pl-4 text-gray`}
  h3 {
    ${tw`font-bold text-xl uppercase leading-tight`}
  }
  h3 + p {
    ${tw`mt-2`}
  }
  p {
    ${tw`leading-normal`}
  }
  * + * {
    ${tw`mt-2`}
  }
`
const IconGridBlock = ({ block }) => {
  const iconGridItems = get(block, "elements.icon_grid_items.value")
  const columns = get(block, "elements.columns.value[0].codename")

  return (
    <StyledIconGrid>
      {iconGridItems.map((item) => {
        const id = get(item, "system.id")

        return (
          <IconGridColumn key={id} columns={columns}>
            <IconGridItem item={item} />
          </IconGridColumn>
        )
      })}
    </StyledIconGrid>
  )
}

export default IconGridBlock

const IconGridItem = ({ item }) => {
  const icon = get(
    item,
    "elements.icon.value[0].elements.image.value[0]"
  )
  const altText = get(
    item,
    "elements.image.value[0].elements.alt_text.value"
  )
  const heading = get(item, "elements.heading.value")

  const text = get(item, "elements.text.value")
  const link = linkTransformer(item)

  return (
    <StyledIconGridItem>
      <IconCol>
        {icon && (
          <Picture image={icon} cropWidth={128} cropRatio={1} alt={altText} />
        )}
      </IconCol>
      <TextCol>
        <Text>
          {heading ? <h3>{heading}</h3> : null}
          {text ? <div dangerouslySetInnerHTML={{ __html: text }} /> : null}
          {link.to && link.label ? (
            <Button
              type="underline"
              to={link.to}
              openInNewWindow={link.openInNewWindow}
              as={Link}
            >
              {link.label}
            </Button>
          ) : null}
        </Text>
      </TextCol>
    </StyledIconGridItem>
  )
}
